// extracted by mini-css-extract-plugin
export default {"otp":"index_otp__7F5J8","signpreview":"index_signpreview__cjkCb","background":"index_background__sBYZS","approvebutton":"index_approvebutton__jxBpd"};